import { render, staticRenderFns } from "./MulticastProxyTable.vue?vue&type=template&id=6afeaf68&"
import script from "./MulticastProxyTable.vue?vue&type=script&lang=js&"
export * from "./MulticastProxyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports